module.exports = __webpack_public_path__ + "static/media/content-11.c8f5e716.svg";